import React from "react";

import { RichTextBlock as BaseRichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import styles from "./rich-text.module.scss";

type TerminalMargin = "both" | "none" | "firstChild" | "lastChild";

interface Props extends React.ComponentProps<typeof BaseRichTextBlock> {
    /**
     * Usually we want the margin-top of the rich text's first child and the
     * margin-bottom of the rich text's last child to be trimmed so they don't
     * affect the layout. But there are some cases where it's useful, so here
     * are a few ways out if you need them.
     */
    trimTerminalMargins?: TerminalMargin;
    largeHeadings?: boolean;
}

export function RichText({
    trimTerminalMargins = "both",
    largeHeadings,
    ...props
}: Props) {
    return (
        <BaseRichTextBlock
            {...props}
            className={concatClassNames([
                styles.richText,
                largeHeadings ? styles.largeHeadings : "",
                styles[trimTerminalMargins],
                props.className,
            ])}
        />
    );
}
